import { formatSpecificMenuItems } from 'utils/cms/formatMenuItems';

const footerClassicMenuItems = [
  {
    key: 30994,
    label: 'footer.tools',
    href: '#',
    selected: false,
    items: [
      {
        key: 30995,
        label: 'footer.developerPortal',
        href: '/developers',
        acf: {
          icon: 'fa-classic fa-solid fa-code',
        },
        selected: false,
      },
    ],
  },
  {
    key: 30996,
    label: 'footer.followUs',
    href: '#',
    selected: false,
    items: [
      {
        key: 30997,
        label: 'footer.instagram',
        href: 'https://www.instagram.com/altered_tcg/',
        acf: {
          icon: 'fa-brands fa-instagram',
        },
        selected: false,
      },
      {
        key: 30998,
        label: 'footer.facebook',
        href: 'https://www.facebook.com/AlteredTCG',
        acf: {
          icon: 'fa-brands fa-facebook',
        },
        selected: false,
      },
      {
        key: 30999,
        label: 'footer.twitter',
        href: 'https://twitter.com/Altered_TCG',
        acf: {
          icon: 'fa-brands fa-x-twitter',
        },
        selected: false,
      },
      {
        key: 31000,
        label: 'footer.youtube',
        href: 'https://youtube.com/@Altered_TCG',
        acf: {
          icon: 'fa-brands fa-youtube',
        },
        selected: false,
      },
      {
        key: 31001,
        label: 'footer.tiktok',
        href: 'https://tiktok.com/@altered_tcg',
        acf: {
          icon: 'fa-brands fa-tiktok',
        },
        selected: false,
      },
      {
        key: 31002,
        label: 'footer.artstation',
        href: 'https://www.artstation.com/alteredtcg',
        acf: {
          icon: 'fa-brands fa-artstation',
        },
        selected: false,
      },
      {
        key: 31003,
        label: 'footer.boardGameGeek',
        href: 'https://boardgamegeek.com/boardgame/397393/altered',
        acf: {
          icon: 'fa-kit fa-fak fa-bgg-social',
        },
        selected: false,
      },
    ],
  },
];

const footerLegalClassicMenuItems = [
  {
    key: 1819,
    label: 'footer.websiteTerms',
    href: '/website-terms/',
    selected: false,
  },
  {
    key: 1820,
    label: 'footer.privacyPolicy',
    href: '/privacy-policy/',
    selected: false,
  },
  {
    key: 1821,
    label: 'footer.cookiePolicy',
    href: '/cookie-policy/',
    selected: false,
  },
];

const footerLegalClassicMenuItemsRaw = [
  {
    id: 1819,
    title: {
      rendered: 'footer.websiteTerms',
    },
    url: '/website-terms/',
    selected: false,
    children: [],
  },
  {
    id: 1820,
    title: {
      rendered: 'footer.privacyPolicy',
    },
    url: '/privacy-policy/',
    selected: false,
    children: [],
  },
  {
    id: 1821,
    title: {
      rendered: 'footer.cookiePolicy',
    },
    url: '/cookie-policy/',
    selected: false,
    children: [],
  },
  {
    id: 1822,
    title: {
      rendered: 'footer.cookieSettings',
    },
    url: '#',
    acf: {
      action: 'cookie-policy',
    },
    selected: false,
    children: [],
  },
];

const footerSpecificMenuItems = formatSpecificMenuItems(footerLegalClassicMenuItemsRaw);

const discordConfig = {
  title: 'footer.joinDiscord',
  link: {
    title: 'footer.officialServer',
    url: 'https://discord.gg/dvrS33RgbW',
  },
  icon: 'fa-classic fa-brands fa-discord',
};

const useFooter = () => {
  const { 'cookie-policy': cookiePolicy } = footerSpecificMenuItems;

  return {
    discordConfig,
    footerConfig: footerClassicMenuItems,
    legalFooterConfig: footerLegalClassicMenuItems,
    cookiePolicy,
  };
};

export default useFooter;
